export default "__VITE_ASSET__B1hwh0_K__"